<template>
  <section class="bg-[#111] py-14 lg:py-20" aria-labelledby="cta-heading">
    <div class="max-w-screen-xl mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-10">

      <!-- Text + acties -->
      <div class="text-center lg:text-left">
        <p class="text-[0.875rem] font-semibold text-[#FFD500] mb-3 tracking-[0.02em] uppercase">
          Persoonlijk advies
        </p>
        <h2 id="cta-heading" class="text-[clamp(1.75rem,4vw,2.5rem)] font-black text-white leading-[1.15] mb-3">
          Niet zeker waar je moet beginnen?
        </h2>
        <p class="text-[1.0625rem] text-[#aaa] leading-[1.7] max-w-[540px] mb-8">
          Onze energiespecialisten helpen je gratis met het samenstellen van de ideale oplossing voor jouw situatie.
        </p>

        <!-- Acties -->
        <div class="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
          <a
            href="mailto:info@plug2charge.nl"
            class="cta-btn cta-btn--primary focus-visible:outline-[3px] focus-visible:outline-[#FFD500] focus-visible:outline-offset-4"
            aria-label="Mail naar info@plug2charge.nl"
          >
            <i class="bi bi-envelope text-[1.125rem]" aria-hidden="true"></i>
            Stuur een mail
          </a>

          <a
            href="/klantenservice#livechat"
            class="cta-btn cta-btn--ghost focus-visible:outline-[3px] focus-visible:outline-[#FFD500] focus-visible:outline-offset-4"
          >
            <i class="bi bi-chat-dots text-[1.125rem]" aria-hidden="true"></i>
            Live chat
          </a>
        </div>
      </div>

      <!-- Medewerker-foto (alleen desktop) -->
      <img
        :src="'/wp-content/uploads/2026/07/thomas_batterij-removebg-preview.png?w=760'"
        alt="Medewerker van Plug2Charge met een draagbare thuisbatterij"
        loading="lazy"
        width="425"
        height="586"
        class="block h-[240px] lg:h-[360px] w-auto shrink-0 self-center lg:self-end drop-shadow-[0_12px_28px_rgba(0,0,0,0.55)]"
      />

    </div>
  </section>
</template>

<style scoped>
.cta-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  font-weight: 700;
  font-size: 1rem;
  padding: 0.875rem 1.75rem;
  border-radius: 6px;
  text-decoration: none;
  white-space: nowrap;
  transition: background 150ms cubic-bezier(0.23, 1, 0.32, 1),
              transform 150ms cubic-bezier(0.23, 1, 0.32, 1),
              box-shadow 150ms cubic-bezier(0.23, 1, 0.32, 1);
}
.cta-btn:hover  { transform: translateY(-2px); }
.cta-btn:active { transform: scale(0.98) translateY(0); }

.cta-btn--primary { background: #FFD500; color: #111; }
.cta-btn--primary:hover {
  background: #ffb800;
  box-shadow: 0 6px 20px rgba(255, 213, 0, 0.45);
}

.cta-btn--ghost {
  background: rgba(255,255,255,0.10);
  color: #fff;
  border: 2px solid rgba(255,255,255,0.25);
  backdrop-filter: blur(4px);
}
.cta-btn--ghost:hover {
  background: rgba(255,255,255,0.20);
  border-color: rgba(255,255,255,0.50);
}

@media (prefers-reduced-motion: reduce) {
  .cta-btn { transition: none; }
}
</style>
